<template>
  <div>
    <!-- 头部链接 -->
    <global-header></global-header>
    <!-- <home-search></home-search> -->
    <router-view></router-view>
    <side-nav></side-nav>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer/index'
import HomeSearch from '@/views/homePage/components/HomeSearch'
import GlobalHeader from '@/components/GlobalHeader'
import SideNav from '@/components/SideNav/index'
export default {
  components: {
    HomeSearch,
    GlobalHeader,
    Footer,
    SideNav,
  }
}
</script>